// extracted by mini-css-extract-plugin
module.exports = {"linkBox":"link-to-context_linkBox__2d2W3","linkBoxParent":"link-to-context_linkBoxParent__p_Fv_","pad":"link-to-context_pad__y706L","accordion":"link-to-context_accordion__SKscf"};